import { useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import moment from "moment";

const PersonalForms = ({ title, setTitle, forenames, setForeNames, surname, setSurname, dob, setDob, gender, setGender, setMaritalStatus, maritalStatus, placeOfBirth, setPlaceOfBirth, nationality, setNationality, citizenship, setCitizenship, idNumber, setIdNumber, email, setEmail, phoneNumber, setPhoneNumber, address, setAddress }) => {

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });
        
        var defaultDate= new Date('January 1, 2010');

        var datepicker = document.querySelectorAll('.datepicker');
        let selectedDate;
        M.Datepicker.init(datepicker, {
            yearRange: [1980,2010],
            showMonthAfterYear: true,
            defaultDate,
            setDefaultDate: true,
            format: 'dd mmmm yyyy',
            onSelect: (date) => {
                selectedDate = moment(date).format('DD MMMM YYYY');
            },
            onClose: () => {
                setDob(selectedDate);
            }
        });

    }, [setDob]);
    
    return ( 
        <>
            <h5 className="title is-size-5-touch has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Personal Details</h5>
            <div className="divider mb-5"></div>

            <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className="input-field col s4 m2">
                            <select onChange={(e) => setTitle(e.target.value)} value={title}>
                                <option value="" disabled>Select</option>
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Miss">Miss</option>
                            </select>
                            <label>Title:</label>
                        </div>
                        <div className="input-field col s8 m5 l4">
                            <input id="lastName" type="text" onChange={(e) => setSurname(e.target.value)} value={surname} />
                            <label htmlFor="lastName" className="active">Last Name:</label>
                        </div>
                        <div className="input-field col s12 m5 l6">
                            <input id="firstName" type="text" onChange={(e) => setForeNames(e.target.value)} value={forenames} />
                            <label htmlFor="firstName" className="active">Forename(s):</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12 m4">
                            <input id="dateOfBirth" type="text" className="datepicker" defaultValue={dob} />
                            <label htmlFor="dateOfBirth" className="active">Date Of Birth:</label>
                        </div>
                        <div className="input-field col s4">
                            <select onChange={(e) => setGender(e.target.value)} value={gender} >
                                <option value="" disabled>Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            <label>Gender:</label>
                        </div>
                        <div className="input-field col s4">
                            <select onChange={(e) => setMaritalStatus(e.target.value)} value={maritalStatus} >
                                <option value="" disabled>Select</option>
                                <option value="Single">Single</option>
                                <option value="Married">Married</option>
                            </select>
                            <label>Marital Status:</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12 m3">
                            <input id="pob" type="text" onChange={(e) => setPlaceOfBirth(e.target.value)} value={placeOfBirth} />
                            <label htmlFor="pob" className="active">Place of Birth:</label>
                        </div>
                        <div className="input-field col s12 m4">
                            <input id="nationality" type="text" onChange={(e) => setNationality(e.target.value)} value={nationality} />
                            <label htmlFor="nationality" className="active">Nationality:</label>
                        </div>
                        <div className="input-field col s12 m5">
                            <input id="citizenship" type="text" onChange={(e) => setCitizenship(e.target.value)} value={citizenship} />
                            <label htmlFor="citizenship" className="active">Citizenship:</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12 m6">
                            <input id="idNumber" type="text" onChange={(e) => setIdNumber(e.target.value)} value={idNumber} />
                            <label htmlFor="idNumber" className="active">National ID No. (e.g 12-3456A78):</label>
                        </div>
                        <div className="input-field col s12 m6">
                            <input id="email" type="email" className="validate" onChange={(e) => setEmail(e.target.value)} value={email} />
                            <label htmlFor="email" className="active">Email:</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12 m5">
                            <input id="phoneNumber" type="text" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} />
                            <label htmlFor="phoneNumber" className="active">Phone Number:</label>
                        </div>
                        <div className="input-field col s12 m7">
                            <textarea id="address" className="materialize-textarea" onChange={(e) => setAddress(e.target.value)} value={address}></textarea>
                            <label htmlFor="address" className="active">Address:</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4 mb-4">
                <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span>All Fields are required to proceed to the next step.</p>
            </div>
        </>
    
     );
}
 
export default PersonalForms;